import { observable } from "mobx";
import { ApprovalState } from "../../approvalState";
import RefundApprovalType from "../../refundApprovalType";
import DistributorPaymentRequestType from "../../distributorPaymentRequestType";
import DecimalRangeRequest from "../../decimalRangeRequest";
import type { EntityValidationRules } from "../../../services/validationService";

export default class DistributorRefundsSearchFilter {
  @observable _approvalState?: ApprovalState;
  @observable approvedBy?: RefundApprovalType;
  @observable fullTextSearchEnabled? = false;
  @observable distributorName?: string;
  @observable distributorsRequestType?: DistributorPaymentRequestType;
  @observable distributorsRequestVariableSymbol?: number;
  @observable amount?: DecimalRangeRequest;
  @observable variableSymbol?: number;
}

export const DistributorRefundsSearchFilterValidationRules: EntityValidationRules<DistributorRefundsSearchFilter> = {
  amount: {
    isNumberRange: {
      min: 0,
    },
  },
};
